function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWi = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(52.89917%,16.499329%,21.199036%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(52.89917%,16.499329%,21.199036%)",
      fillOpacity: 1
    },
    d: "M 81.167969 50.515625 C 80.0625 47.398438 78.082031 38.679688 78.082031 34.882813 C 78.082031 31.082031 81.542969 26.574219 81.542969 26.574219 L 69.046875 15.203125 C 69.046875 15.203125 63.894531 17.5625 60.292969 17.164063 C 57.003906 16.796875 49.671875 11.984375 49.671875 11.984375 C 49.671875 11.984375 42.984375 16.796875 39.699219 17.164063 C 36.097656 17.5625 30.292969 15.128906 30.292969 15.128906 L 18.324219 26.5 C 18.324219 26.5 21.539063 31.679688 21.539063 35.480469 C 21.539063 39.277344 19.96875 47.597656 18.769531 51.117188 C 17.703125 54.25 15.804688 60.222656 16.605469 63.421875 C 17.402344 66.621094 19.804688 71.519531 24.203125 74.019531 C 28.480469 76.441406 35.398438 79.617188 37.199219 80.617188 C 38.996094 81.617188 47.394531 85.414063 49.996094 88.015625 C 52.59375 85.414063 60.992188 81.617188 62.792969 80.617188 C 64.59375 79.617188 71.507813 76.441406 75.789063 74.019531 C 80.1875 71.519531 82.585938 66.621094 83.386719 63.421875 C 84.183594 60.222656 82.367188 53.882813 81.167969 50.515625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.698547%,74.099731%,13.699341%)",
      fillOpacity: 1
    },
    d: "M 76.304688 34.355469 C 76.304688 32.457031 78.851563 26.574219 78.851563 26.574219 C 78.851563 26.574219 70.566406 18.941406 68.75 17.523438 C 68.75 17.523438 63.589844 19.394531 59.546875 18.871094 C 55.507813 18.34375 49.738281 14.335938 49.738281 14.335938 C 49.738281 14.335938 43.34375 18.589844 40.222656 18.9375 C 36.808594 19.316406 30.898438 17.335938 30.898438 17.335938 L 20.78125 26.929688 C 20.78125 26.929688 23.46875 32.078125 23.46875 35.679688 C 23.46875 39.285156 21.695313 48.117188 20.46875 51.222656 C 19.304688 54.132813 17.546875 59.722656 18.304688 62.761719 C 19.066406 65.796875 21.34375 70.445313 25.515625 72.816406 C 29.578125 75.117188 36.144531 78.128906 37.851563 79.078125 C 39.558594 80.027344 47.527344 83.632813 49.996094 86.097656 C 52.460938 83.632813 60.429688 80.027344 62.140625 79.078125 C 63.847656 78.128906 70.410156 75.117188 74.472656 72.816406 C 78.648438 70.445313 81.34375 65.847656 81.851563 62.761719 C 82.835938 56.800781 76.304688 45.355469 76.304688 34.355469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(28.199768%,73.699951%,89.7995%)",
      fillOpacity: 1
    },
    d: "M 77.828125 51.328125 C 76.765625 48.550781 74.59375 39.296875 74.59375 35.882813 C 74.59375 32.472656 76.75 27.355469 76.75 27.355469 L 68.488281 19.542969 C 68.488281 19.542969 62.472656 21.070313 59.242188 20.710938 C 56.289063 20.382813 49.996094 16.769531 49.996094 16.769531 C 49.996094 16.769531 43.699219 20.382813 40.746094 20.710938 C 37.515625 21.070313 31.5 19.542969 31.5 19.542969 L 23.242188 27.355469 C 23.242188 27.355469 25.394531 32.472656 25.394531 35.882813 C 25.394531 39.296875 23.417969 48.632813 22.164063 51.328125 C 21.757813 52.195313 21.316406 53.328125 20.925781 54.558594 L 78.925781 54.558594 C 78.570313 53.378906 78.179688 52.253906 77.828125 51.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,60.398865%,84.698486%)",
      fillOpacity: 1
    },
    d: "M 20.925781 54.558594 C 20.105469 57.140625 19.523438 60.15625 20.007813 62.101563 C 20.726563 64.972656 22.882813 69.371094 26.832031 71.617188 C 30.675781 73.792969 36.886719 76.644531 38.503906 77.542969 C 40.121094 78.441406 47.660156 81.851563 49.996094 84.183594 C 52.332031 81.851563 59.871094 78.441406 61.484375 77.542969 C 63.101563 76.644531 69.316406 73.792969 73.15625 71.617188 C 77.109375 69.371094 79.175781 64.949219 79.980469 62.101563 C 80.429688 60.511719 79.773438 57.371094 78.925781 54.558594 L 20.925781 54.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,65.899658%,31.399536%)",
      fillOpacity: 1
    },
    d: "M 41.21875 42.136719 C 41.21875 42.136719 37.699219 40.34375 32.984375 41.539063 C 34.457031 40.042969 38.671875 38.210938 38.671875 38.210938 C 38.671875 38.210938 34.183594 35.253906 28.046875 40.191406 C 28.199219 38.246094 30.59375 34.804688 37.625 32.859375 C 35.980469 32.859375 31.789063 32.5625 29.695313 33.609375 C 31.339844 31.8125 35.832031 29.117188 38.371094 28.96875 C 38.371094 28.96875 36.253906 27.921875 33.558594 28.671875 C 33.558594 28.671875 37.511719 26.238281 39.308594 26.539063 C 39.308594 26.539063 38.746094 24.816406 37.476563 24.480469 C 37.476563 24.480469 39.796875 24.816406 41.292969 26.164063 C 42.9375 25.117188 45.554688 24.628906 45.707031 24.628906 C 45.855469 24.628906 44.058594 25.566406 44.058594 26.464844 C 45.105469 26.761719 48.25 27.472656 49.148438 28.519531 C 47.128906 28.332031 45.53125 28.222656 44.335938 28.96875 C 45.679688 29.269531 51.539063 30.316406 53.933594 34.507813 C 50.792969 33.460938 46.304688 32.859375 44.957031 33.308594 C 46.601563 33.757813 53.484375 35.105469 54.832031 39.292969 C 52.8125 38.246094 46.628906 36.101563 44.359375 37.351563 C 46.601563 38.398438 49.445313 39.894531 50.34375 42.136719 C 47.378906 41.140625 43.460938 40.789063 41.21875 42.136719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,65.899658%,31.399536%)",
      fillOpacity: 1
    },
    d: "M 34.832031 74.210938 L 65.558594 74.210938 C 65.558594 74.210938 64.160156 58.648438 49.996094 58.648438 C 35.832031 58.648438 34.832031 74.210938 34.832031 74.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.698547%,74.099731%,13.699341%)",
      fillOpacity: 1
    },
    d: "M 64.792969 42.039063 C 69.265625 42.039063 72.890625 38.621094 72.890625 34.410156 C 72.890625 30.195313 69.265625 26.78125 64.792969 26.78125 C 60.320313 26.78125 56.695313 30.195313 56.695313 34.410156 C 56.695313 38.621094 60.320313 42.039063 64.792969 42.039063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.099304%,26.699829%,15.299988%)",
      fillOpacity: 1
    },
    d: "M 42.300781 73 C 42.300781 73 36.429688 59.246094 40.019531 41.6875 L 42.113281 41.6875 C 42.113281 41.6875 39.222656 58.046875 46.601563 73.011719 L 42.300781 73 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.698547%,74.099731%,13.699341%)",
      fillOpacity: 1
    },
    d: "M 51.988281 69.023438 L 53.1875 69.023438 L 53.1875 50.269531 L 51.988281 50.269531 L 51.988281 69.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.698547%,74.099731%,13.699341%)",
      fillOpacity: 1
    },
    d: "M 54.648438 69.023438 L 55.84375 69.023438 L 55.84375 50.269531 L 54.648438 50.269531 L 54.648438 69.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.698547%,74.099731%,13.699341%)",
      fillOpacity: 1
    },
    d: "M 57.300781 69.023438 L 58.5 69.023438 L 58.5 50.269531 L 57.300781 50.269531 L 57.300781 69.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.698547%,74.099731%,13.699341%)",
      fillOpacity: 1
    },
    d: "M 52.347656 50.273438 L 58.179688 50.273438 L 58.179688 49.078125 L 52.347656 49.078125 L 52.347656 50.273438 "
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wi.265690011bb611ee4aacf799ba99e71d.svg";